import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UrlSegment, UrlMatchResult } from '@angular/router';
import { ImagesModule } from '@app/shared/components/images/images.module';
import { NotFoundComponent } from './not-found.component';
import { NotFoundRoutingModule } from './not-found-routing.module';
import { SharedModule } from '@app/shared/shared.module';

export function notFoundMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length >= 1 && url[0].path === 'not-found' ? { consumed: url } : null;
}

@NgModule({
  imports: [CommonModule, NotFoundRoutingModule, ImagesModule, SharedModule],
  declarations: [NotFoundComponent],
  exports: [NotFoundComponent]
})
export class NotFoundModule {}
